import pick from 'lodash.pick';
import pickBy from 'lodash.pickby';
import { customersApi } from '@/api';

const apiObjectKeys = [
  'productCode',
  'productName',
  'customerProductName',
  'lot',
  'date',
  'notes',
  'finalCustomer',
  'customerAddress',
  'comments',
  'addressId',
  'sector',
  'sampleDescription',
  'packagesNumber',
  'costCenter',
  'analysisNotes',
  'labNotes',
];

// Optional sample fields that the revision form lets you clear and that map to a
// nullable Sample column. A cleared value must be sent as an explicit null so the
// backend update removes it (pickBy would otherwise drop the falsy value, leaving
// stale data on the sample and the generated document). Required fields (sector,
// sampleDescription, packagesNumber), the non-nullable productName, and fields not
// persisted on the Sample by the revision update (e.g. analysisNotes) are excluded.
const clearableSampleKeys = [
  'productCode',
  'customerProductName',
  'lot',
  'date',
  'notes',
  'comments',
  'costCenter',
  'labNotes',
  'finalCustomer',
];

const analysisStatusManagementHelper = {
  serializeSample(sample) {
    const pickedObject = pickBy(
      pick(sample, apiObjectKeys) // pick only requested values
    ); // remove falsy values
    // pickBy strips falsy values, so a cleared optional field would be omitted
    // from the payload and the old value would silently remain on the sample and
    // its document. Send an explicit null for every clearable field so the update
    // actually clears it. (Required fields are intentionally not listed here.)
    clearableSampleKeys.forEach((key) => {
      if (!sample[key]) {
        pickedObject[key] = null;
      }
    });
    return pickedObject;
  },
  async createAddress(formData, customerId) {
    if (formData.customerHeaderData && formData.addressId === null) {
      const { customerHeaderData, id, ...addressData } = formData.address;
      const newAddressResponse = await customersApi.createAddress(
        customerId,
        addressData
      );
      return { ...formData, addressId: newAddressResponse.data.id };
    }
    return { ...formData };
  },
  async updateAddressCountryFields(formData) {
    const patch = formData.addressCountryPatch;
    if (formData.addressId && patch && Object.keys(patch).length) {
      await customersApi.updateAddressCountryFields(formData.addressId, patch);
    }
  },
};

export default analysisStatusManagementHelper;
